import React from 'react';
import {compose} from "../../utils";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {
    setDelivery,
} from "../../actions";

class Delivery extends React.Component {
    render() {
        return (
            <>
                <div className="radioBox__container radioBox__delivery modalType2__deliveryContainer">
                    <p className="radioBox__container--title">Способ доставки:</p>
                    {this.props.deliveryPrice.courier > 0 &&
                        <div className="radiobox">
                            <input className="radio_input" type="radio" id="rb2"
                                   onChange={e => this.props.setDelivery("courier")} checked={this.props.delivery === "courier"}/>
                            <label htmlFor="rb2">Доставка курьером ({this.props.deliveryPrice.courier} &#8381;)</label>
                        </div>
                    }
                    {this.props.deliveryPrice.post > 0 &&
                        <div className="radiobox">
                            <input className="radio_input" type="radio" id="rb3"
                                   onChange={e => this.props.setDelivery("post")} checked={this.props.delivery === "post"}/>
                            <label htmlFor="rb3">Почта России ({this.props.deliveryPrice.post} &#8381;)</label>
                        </div>
                    }
                    {this.props.deliveryPrice.courier == 0 && this.props.deliveryPrice.post == 0 &&
                        <p style={{fontSize: "12px", marginBottom: "10px"}}>К сожалению, доставка в ваш населенный пункт временно не производится</p>
                    }
                </div>
                <p style={{fontSize: "12px", lineHeight: "16px", marginBottom: "10px"}}>Стоимость доставки зависит от города получателя</p>
            </>
        );
    }
}

const mapStateToProps = ({deliveryPrice, delivery}) => {
    return {deliveryPrice, delivery};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setDelivery,
    }, dispatch);
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(Delivery);
